import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Overline, CTASecondary } from "@/components/primitives";
import { useArticles } from "@/lib/useArticles";

export function ArticleRows({ articles }) {
  return (
    <div className="border-t hairline" data-testid="perspectives-list">
      {articles.map((a, i) => (
        <Reveal key={a.slug} delay={i * 0.05}>
          <Link
            to={`/perspectives/${a.slug}`}
            data-testid={`perspective-row-${a.slug}`}
            className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-10 md:py-12 border-b hairline items-baseline"
          >
            <div className="md:col-span-2 flex items-center gap-4">
              <span className="overline text-gold">{a.category}</span>
            </div>
            <div className="md:col-span-8">
              <h3 className="font-heading font-light text-navy text-2xl md:text-4xl leading-tight group-hover:text-navy/60 transition-colors duration-300">
                {a.title}
              </h3>
              <p className="mt-3 text-ink/60 max-w-2xl font-body md:text-lg leading-relaxed">{a.excerpt}</p>
            </div>
            <div className="md:col-span-2 flex items-center justify-between md:justify-end gap-4 text-navy/50">
              <span className="text-xs uppercase tracking-widest">{a.read_time}</span>
              <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </div>
          </Link>
        </Reveal>
      ))}
    </div>
  );
}

export default function PerspectivesTeaser() {
  const { articles } = useArticles();
  return (
    <section className="py-24 md:py-36 border-b hairline" data-testid="perspectives-teaser">
      <div className="mx-auto max-w-[1500px] px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <Reveal><Overline>07 — Perspectives</Overline></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-8 font-heading font-light text-navy tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
                Visibility Intelligence
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-6 text-lg leading-relaxed text-ink/70 font-body max-w-xl">
                Perspectives on the platforms, ecosystems and conversations shaping where business
                influence is built.
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <CTASecondary to="/perspectives" testId="perspectives-view-all">View all perspectives</CTASecondary>
          </Reveal>
        </div>
        <ArticleRows articles={articles.slice(0, 4)} />
      </div>
    </section>
  );
}
